module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.meta.keepAlive) ? _c('keep-alive', [_c('router-view', {
    key: _vm.$route.name
  })], 1) : _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-892541bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 2357
// module chunks = 0